<page-title text="Invite & Earn | BitOasis" i18n-text="@@pageTitle.affiliateProgram"></page-title>

<site-header></site-header>

<section class="header section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 content">
        <h1 class="text-title" i18n="@@front.affiliateProgram.title">Invite Your Friends and Earn Up to <strong>{{reward.amount | number:'0.2'}} {{reward.currency}} Each</strong></h1>
        <p class="text-subtitle" i18n="@@front.affiliateProgram.subtitle">Earn rewards with each successful deposit and buy order on BitOasis with the most competitive reward program yet.</p>
        <div class="p-3"></div>
        <ng-container *ngTemplateOutlet="actionBtns"></ng-container>
      </div><!-- .content -->
      <div class="col-lg-6 img">
        <img src="assets/images/referral/referral-hero.png" alt="Invite and Earn">
      </div><!-- .img -->
    </div><!-- .row -->
  </div><!-- .container -->
</section>

<section class="section container">
  <div class="row how-it-works">
    <div class="col-lg-4 item-wrapper">
      <div class="item text-center">
        <div class="step">1</div>
        <h3 i18n="@@affiliatePoints.howItWorks.lgoin.title">Login/Register</h3>
        <p i18n="@@affiliatePoints.howItWorks.lgoin.description">Register your Interest in joining the BitOasis affiliate program as a Marketer. Our team will carefully review your application. If approved, you’ll receive marketing material, guidelines, as well as your unique affiliate link to track each referral.</p>
      </div>
    </div>
  
    <div class="col-lg-4 item-wrapper">
      <div class="item text-center">
        <div class="step">2</div>
        <h3 i18n="@@affiliatePoints.howItWorks.refer.title">Refer Friends</h3>
        <p i18n="@@affiliatePoints.howItWorks.refer.description">Under the "Refer and Earn" tab, you can use your unique referral tracking link. Share your unique link with your friends, traders or on social media.</p>
      </div>
    </div>
  
    <div class="col-lg-4 item-wrapper">
      <div class="item text-center">
        <div class="step">3</div>
        <h3 i18n="@@affiliatePoints.howItWorks.earn.title">Both Get Rewarded</h3>
        <p i18n="@@affiliatePoints.howItWorks.earn.description">Whenever any of your referred list successfully completes a deposit and buy amount within the reward structure, both of you earn rewards! The more users you bring to use BitOasis to buy digital assets, the more rewards you earn.</p>
      </div>
    </div>
  </div>
</section>

<section class="container section">
  <h3 class="section-title text-center text-bold" i18n="@@front.affiliateProgram.rewards.title">Reward Structure</h3>
  <affiliate-rewards [currency]="fiatCurrency"></affiliate-rewards>
</section>

<section class="boxed bg-white container section">
  <div class="p-2"></div>
  <h3 class="section-title text-center text-bold" i18n="@@front.affiliateProgram.features.title">Features</h3>
  <div class="p-1"></div>
  <div class="row features">
    <div class="col-lg-6 feature">
      <img src="assets/images/affiliate-program/refer.svg" alt="Tracking">
      <div class="p-2"></div>
      <div class="content">
        <h3 i18n="@@affiliatePoints.features.tracking.title">Referral Tracking Dashboard</h3>
        <p i18n="@@affiliatePoints.features.tracking.description">Track where your invited friends are and get notified whenever you receive rewards through the dedicated referral dashboard</p>
      </div>
    </div>
    <div class="col-lg-6 feature">
      <img src="assets/images/affiliate-program/earn.svg" alt="Earn">
      <div class="p-2"></div>
      <div class="content">
        <h3 i18n="@@affiliatePoints.features.earn.title">Withdraw to your Bank Account</h3>
        <p i18n="@@affiliatePoints.features.earn.description">You can withdraw your rewards to your bank account conveniently with no additional steps</p>
      </div>
    </div>
  </div><!-- .features -->
</section>

<div class="section container">
  <ng-container *ngTemplateOutlet="actionBtns; context: {center: true}"></ng-container>
</div>

<div class="section container">
  <start-steps></start-steps>
</div>

<site-footer></site-footer>

<ng-template #actionBtns let-center="center">
  <div class="action-btns" [class.justify-content-center]="center">
    <a *ngIf="!isLoggedIn" routerLink="/register" class="btn btn-lg btn-primary action" i18n="@@front.affiliateProgram.mainAction.start">Start Now</a>
    <a *ngIf="isLoggedIn" routerLink="/affiliate-program" class="btn btn-lg btn-primary action" i18n="@@front.affiliateProgram.mainAction.invite">Invite Now</a>
    <div class="spacer"></div>
    <a routerLink="/page/invite-earn-program-guidelines" target="_blank" class="btn btn-lg btn-outline action" i18n="@@front.affiliateProgram.mainAction.learnMore">Learn More</a>
  </div>
</ng-template>